"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable no-param-reassign */
const _ = __importStar(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const getConcentrationLimitValue = (principalBalance) => {
    // 100% when the principalBalance < $4,000,000
    // 35% when the principalBalance >= $4,000,000
    // 30% when the principalBalance >= $8,000,000
    if (principalBalance < 4000000)
        return 1;
    if (principalBalance >= 8000000)
        return 0.3;
    return 0.35;
};
exports.concentrationLimitPointerMethods = [
    {
        method: 'vayaPier1.maximumPlatformConcentration',
        pointerImplementation: ({ concentrationReceivables, totalConcentrationExposure, }) => {
            (0, common_1.finleyAssert)(concentrationReceivables.length, new common_1.error.FinleyError(`expected concentrationReceivables to not be an empty array`));
            const { principalBalance, } = concentrationReceivables[0].dynamicIntermediateFields;
            (0, common_1.finleyAssert)(_.isNumber(principalBalance), new common_1.error.FinleyError(`expected principalBalance to be a number but got ${principalBalance}`));
            const concentrationLimit = getConcentrationLimitValue(principalBalance);
            const groupingId = 'platform';
            (0, common_1.finleyAssert)(_.every(concentrationReceivables, (rec) => _.isString(rec.baseFields[groupingId])), new common_1.error.FinleyError(`baseFields.${groupingId} must be defined to run vayaPier1.maximumPlatformConcentration`));
            const groupedByPlatform = _.groupBy(concentrationReceivables, (rec) => rec.baseFields[groupingId]);
            const standardBorrowingBaseReductions = _.map(_.entries(groupedByPlatform), ([, receivables]) => {
                return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
                    concentrationLimit,
                    totalConcentrationExposure,
                    concentrationReceivables: receivables,
                    concentrationLimitValueType: 'percentage',
                });
            });
            // accumulate all breaches into a single standard borrowing base reduction
            let concentrationAmount = 0;
            const concentrationKickouts = _.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
                const _result = { ...result };
                // add in concentrationAmount if over limit, cannot do in toPairs below since it will count the amount multiple times
                if (calculations.concentration > calculations.concentrationLimit) {
                    concentrationAmount += calculations.concentrationAmount || 0;
                }
                _.forEach(_.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
                    if (kickout === 0)
                        return true;
                    if (!_result[finleyReceivableId]) {
                        _result[finleyReceivableId] = 0;
                    }
                    _result[finleyReceivableId] += kickout;
                    return true;
                });
                return _result;
            }, {});
            return {
                kickouts: concentrationKickouts,
                calculations: {
                    concentrationAmount,
                    concentrationLimit: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations
                            .concentrationLimit
                        : 0,
                    concentration: standardBorrowingBaseReductions.length > 0
                        ? standardBorrowingBaseReductions[0].calculations.concentration
                        : 0,
                },
            };
        },
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map